module.exports = __webpack_public_path__ + "quotezone-ui/img/rim-white.32536206.png";